export default __webpack_public_path__ + "static/media/double-both-border-both.6f705b87.svg";